import React, { ReactElement, useEffect } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import serverConfig from '@/server-config'
import ModelMarketCardDetails from '@/components/market/ModalMarketCardDetails'

axios.defaults.baseURL = serverConfig.baseURL

const DetailsOverview = ({ artData, onClose }: { artData: ArtData; onClose: () => void }): ReactElement => {
    useEffect(() => {
        window.location.hash = `nft-${artData.tokenId?.toString()}#market`
    }, [artData])

    return (
        <div>
            <h1 className="title">CRAZY NFT #{artData.tokenId}</h1>
            <div className="container">
                <div>
                    <ModelMarketCardDetails artData={artData} onClose={onClose} />
                </div>
            </div>
        </div>
    )
}
DetailsOverview.whyDidYouRender = true

export default DetailsOverview
